export const ADD_CREATED_KEY = 'ADD_CREATED_KEY'
export const SET_API_KEYS = 'SET_API_KEYS'
export const SET_CREATED_KEY = 'SET_CREATED_KEY'
export const SET_GENERATE_KEY_MODAL_OPEN = 'SET_GENERATE_KEY_MODAL_OPEN'
export const PENDING_REVOKE_API_KEY = 'PENDING_REVOKE_API_KEY'
export const COMPLETED_REVOKE_API_KEY = 'COMPLETED_REVOKE_API_KEY'
export const SUCCESSFUL_REVOKE_API_KEY = 'SUCCESSFUL_REVOKE_API_KEY'
export const RESET_API_KEY = 'RESET_API_KEY'
